import React from "react";

import { setShowForm, reset } from "../../redux/profile/settings/changePass/slice";
import { useAppDispatch, useAppSelector } from "../../redux/store";

import { Modal, CommonErrorModal, Button } from "../../components";
import { PhoneForm, SmsCodeForm, NewPasswordForm } from "./Forms";

import styles from "./PassChangeMockPage.module.scss";

import { ModalTexts } from "../../resources/locale";
import {FormNames, WindowNames} from "../../resources/constants";

import { PassChangePropsType } from "./types";
import { useNavigate } from "react-router";
import {openModal, closeModal} from "react-url-modal";
import {setShowWindow} from "../../redux/profile/authAndReg/slice";

export const PassChangeModal: React.FC<PassChangePropsType> = (props) => {
  const { isOpen, setIsOpen, title, subTitle,forcedShowForm,closeModal: closeModalProp } = props;
  
  const selector = useAppSelector(state => state.changePass)
  const { auth, isLoading } = useAppSelector(state => state.authAndReg);
  const hasClosedRef = React.useRef(false);
  
  let showForm

  if(forcedShowForm){
    showForm = forcedShowForm
  }else{
    showForm = selector.showForm;
  
  }
  const openChildModal = (window:string,form?:string)=>{
    openModal({name:'login',params:{showWindow: window,showForm:form}})
  }

  const dispatch = useAppDispatch();
  const navigate = useNavigate()

  // Автоматически закрываем модалку после успешной авторизации
  React.useEffect(() => {
    if (auth && !isLoading && !hasClosedRef.current && isOpen) {
      hasClosedRef.current = true;
      const timer = setTimeout(() => {
        dispatch(reset());
        if (closeModalProp) {
          closeModalProp();
        } else {
          closeModal();
        }
      }, 200);
      
      return () => clearTimeout(timer);
    }
    
    if (!isOpen) {
      hasClosedRef.current = false;
    }
  }, [auth, isLoading, isOpen, closeModalProp, dispatch]);

  const modalRenderController = (showForm: string) => {
    switch (showForm) {
      case FormNames.PHONE:
        return (
          <Modal
            title={title}
            subTitle={subTitle}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
            closeModal={closeModalProp}
            mobileContentSize="full-screen-page-header"
          >
            <PhoneForm handleSubmitForm={handleSetCodeForm} />
          </Modal>
        );
      case FormNames.CODE:
        return (
          <Modal
            title={ModalTexts.changePass.inputSmsCode.TITLE}
            subTitle={ModalTexts.changePass.inputSmsCode.SUB_TITLE}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
            closeModal={closeModalProp}
            mobileContentSize="full-screen-page-header"
          >
            <SmsCodeForm handleSubmitForm={handleSetNewPassForm} />
          </Modal>
        );
      case FormNames.PASSWORD:
        return (
          <Modal
            title={ModalTexts.changePass.inputNewPassword.TITLE}
            subTitle={ModalTexts.changePass.inputNewPassword.SUB_TITLE}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
            closeModal={closeModalProp}
            mobileContentSize="full-screen-page-header"
          >
            <NewPasswordForm handleSubmitForm={handleSetPassApplyForm} />
          </Modal>
        );
      case FormNames.PASSWORD_APPLY:
        return (
          <Modal
            title={ModalTexts.changePass.passwordApply.TITLE}
            subTitle={ModalTexts.changePass.passwordApply.SUB_TITLE}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
            closeModal={closeModalProp}
            mobileContentSize="full-screen-page-header"
          >
            <Button newStyles={styles.button} onClickFunc={handleEndChangePassProcess}>
              Ок
            </Button>
          </Modal>
        );
      case FormNames.ERROR:
        return (
          <CommonErrorModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
          />
        );
      case FormNames.ERROR_PHONE:
        return (
          <Modal
            title={ModalTexts.changePass.errorPhone.TITLE}
            subTitle={ModalTexts.changePass.errorPhone.SUB_TITLE}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
            closeModal={closeModalProp}
            mobileContentSize="full-screen-page-header"
          >
            <Button newStyles={styles.button} onClickFunc={handleSetPhoneForm}>
              Назад
            </Button>
          </Modal>
        );
      case FormNames.ERROR_CODE:
        return (
          <Modal
            title={ModalTexts.changePass.errorCode.TITLE}
            subTitle={ModalTexts.changePass.errorCode.SUB_TITLE}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            closeFunc={handleEndChangePassProcess}
            closeModal={closeModalProp}
            mobileContentSize="full-screen-page-header"
          >
            <Button newStyles={styles.button} onClickFunc={handleSetCodeForm}>
              Назад
            </Button>
          </Modal>
        );
      default:
        return null;
    }
  };

  const handleSetPhoneForm = () => {
    dispatch(setShowForm(FormNames.PHONE));
    dispatch(setShowWindow(WindowNames.FORGOT_PASS));
    dispatch(setShowForm(FormNames.PHONE));
    openChildModal(WindowNames.FORGOT_PASS, FormNames.PHONE)
  };

  const handleError = () => {
    dispatch(setShowForm(FormNames.CODE));
    dispatch(setShowWindow(WindowNames.FORGOT_PASS));
    dispatch(setShowForm(FormNames.CODE));
    openChildModal(WindowNames.FORGOT_PASS, FormNames.CODE)
  }

  const handleSetCodeForm = () => {
    dispatch(setShowForm(FormNames.CODE));
    dispatch(setShowWindow(WindowNames.FORGOT_PASS));
    dispatch(setShowForm(FormNames.CODE));
    openChildModal(WindowNames.FORGOT_PASS, FormNames.CODE)
  };

  const handleSetNewPassForm = () => {
    dispatch(setShowForm(FormNames.PASSWORD));
    dispatch(setShowWindow(WindowNames.FORGOT_PASS));
    dispatch(setShowForm(FormNames.PASSWORD));
    openChildModal(WindowNames.FORGOT_PASS, FormNames.PASSWORD)
  };

  const handleSetPassApplyForm = () => {
    dispatch(setShowForm(FormNames.PASSWORD_APPLY));
    dispatch(setShowWindow(WindowNames.FORGOT_PASS));
    dispatch(setShowForm(FormNames.PASSWORD_APPLY));
    openChildModal(WindowNames.FORGOT_PASS, FormNames.PASSWORD_APPLY)
  };

  const handleEndChangePassProcess = () => {
    navigate('/')
    dispatch(reset());
  };

  const currentModal = modalRenderController(showForm);

  return <>{currentModal}</>;
};
